<script>
import { defineComponent } from 'vue';
import CustomerSrv from '@/services/customer.service';
import moment from 'moment';
import vueNumberInput from '@chenfengyuan/vue-number-input';
import Incrementer from '@/helpers/increment.js';
import Favorite from '@/components/global/Favorites.vue';

export default defineComponent({
    name: 'listItem',
    props: {
        item: Object,
    },
	data() {
		return {
			loadingDetail: false,
            qty: {}
		}
	},
    setup() {},
    components: {
        vueNumberInput,
        Favorite
    },
    methods: {
        onHide(evt) {},
        price(p) {
            return new Intl.NumberFormat('en-EN', { minimumFractionDigits: 0, maximumFractionDigits:0 }).format(p)
        },
        defaultIncrement(item) {
            if (item.category=='WIRE') {
                return Incrementer.DefaultCutLength(item.itemNumber, "MFT");
            }
            return 1;
        },
        uom(i) {
            return i.category=="WIRE" ? "MFT" : "EA";
        }
    },
	computed: {
		accessToken() {
			return this.$store.getters['auth/accessToken'];
		},
        createdDate() {
            return moment(this.item.dateCreated).calendar()
        }
	},
    created() {
        this.item.listItems.forEach(i => {
            this.qty[i.itemNumber] = i.quantity>0 ? i.quantity : this.defaultIncrement(i);
        })
    }
})
</script>

<template>
    <q-expansion-item expand-icon-class="wcwBlue expandIconWCW" @hide="onHide()">
        <template v-slot:header>
            <q-item-section>
            <div class="row">
                <div class="col-11 q-pl-md">
                    <h3 style="line-height: 1.5em; font-size: 1.1em">{{item.name}}</h3>
                    <span class="dateCreatedList">Created:<span>{{createdDate}}</span></span>
                </div>
            </div>
            </q-item-section>
            <q-item-section side>
                <span class="q-pt-xs q-pl-sm text-grey-10">Items: {{item.listItems.length}}</span>
            </q-item-section>
        </template>

        <template v-slot:default>
            <div>
                <div class="orderView" v-for="(i, idx) in item.listItems" :key="idx">
                    <div class="row">
                        <div class="col-7">
                            <div class="row">
                                <div class="col-1 q-mr-md">
                                    <favorite :item="i.itemNumber" :accessToken="accessToken"></favorite>
                                </div>
                                <div class="col text-left">
                                    <h3 style="line-height: 1em;">{{i.itemNumber}} </h3>
                                    <p class="productDescription">{{i.description}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-7 q-mt-md">
                                    <vue-number-input v-model.number="qty[i.itemNumber]" :min="defaultIncrement(i)" :step="defaultIncrement(i)" :inputtable="false"  size="small" @input="onInput" controls center></vue-number-input>
                                </div>
                                <div class="col-3 q-ml-xs q-mt-md">
                                    <q-btn color="cyan-7" size="md" :unelevated=true :ripple=true padding="3px 18px 3px 18px" icon="fas fa-cart-plus" :disabled="qty[i.itemNumber]==0" @click="$store.dispatch('cart/addToCart', [accessToken, i.itemNumber, qty[i.itemNumber]])"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="text-right">
                                <q-btn class="q-pa-sm q-mt-xs" size="sm" color="warning" label="Request Price" icon="fas fa-dollar-sign" v-if="i.price==0" style="height: 30px !important;"/>
                                <q-btn unelevated v-if="i.price>0" class="q-pa-sm q-mt-xs" color="positive" :label="`${i.price} ${uom(i)}`" icon="fas fa-dollar-sign" style="height: 25px !important;width: 148px;"/>
                            </div>
                            <div class="q-pt-sm text-right">
                                <q-btn round color="negative" outline icon="far fa-trash" size="sm" @click="$store.commit('customer/setOpenConfirmDeleteListItemModal', true); $store.commit('customer/setSelectedList', item.id); $store.commit('customer/setSelectedListItem', i.itemNumber); " />   
                            </div>
                        </div>
                    </div>
                </div>
                <div class="orderView" >
                    <div class="row">
                        <div class="col-12 text-center">
                            <q-btn class="q-pa-sm" label="Delete List" round color="negative" outline icon="far fa-trash" size="sm" @click="$store.commit('customer/setOpenConfirmDeleteListModal', true); $store.commit('customer/setSelectedList', item.id);" />   
                        </div>
                    </div>
                </div>
            </div>
        </template>

    </q-expansion-item>
    <div class="mobileDiv"></div>
      
</template>

<style>
.expandIconWCW i{font-size: 45px !important; padding-right: 0px;}
</style>